import { z } from 'zod';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

export const EditStudentSchema = z.object({
    first_name: z.string().min(1, 'The full name field is required.'),
    last_name: z.string().min(1, 'The full name field is required.'),
    branch_id: z.string().optional(),
    gender: z.enum(['male', 'female'], {
        required_error: 'الجنس مطلوب',
    }).optional(),
    age: z.number().min(1, 'The age field is required.').optional(),
    notes: z.string().optional(),
    phone: z
        .string()
        .min(1, 'رقم الهاتف مطلوب')
        .refine((val) => /^\d+$/.test(val), 'الرجاء إدخال أرقام فقط')
        .refine((val) => val.length >= 8 && val.length <= 15, 'يجب أن يتكون رقم الهاتف من 8 إلى 15 رقم'),
    address: z.string().min(1, 'Address is required'),
    national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    mother_national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    mother_national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    father_national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    father_national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    emergency_numbers: z.preprocess(
        (val) => {
            if (val === '' || val === null || val === undefined) return undefined;
            if (Array.isArray(val)) return val;
            if (typeof val === 'string') {
                // If it's a comma-separated string, split it
                return val.includes(',') ? val.split(',').map((s) => s.trim()).filter(Boolean) : [val];
            }
            return undefined;
        },
        z.array(z.string()).optional(),
    ),
    // national_id: z.string().min(1, 'The National id number field is required.'),
  

});

export type EditStudentFormValues = z.infer<typeof EditStudentSchema>;
